// removed by extract-text-webpack-plugin
module.exports = {"nav":"_3TGBF82-3JqG1FNEsLHVx-","nav__item":"_24IphctI3p0YJ6T0Ax1mrf","nav__link":"_3lqXtjYR0LZ9D4uA6EoFpu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/nav.scss
// module id = 213
// module chunks = 0